import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { forkJoin } from 'rxjs';
import { StateModel } from 'src/app/core/StateModel';
import { XCourseFilter } from 'src/app/core/common/XCourseFilter';
@Component({
  selector: 'app-x-short-course-list',
  templateUrl: './x-short-course-list.component.html',
  styleUrl: './x-short-course-list.component.scss'
})
export class XShortCourseListComponent {

  // Store selected course type from URL
  courseType: string = '';


  // Store all UOC courses
  allUOCCourses: any[] = [];

  // Store all VOC courses
  allVOCCourses: any[] = [];

  // Store displayed course list
  courses: any[] = [];

  // Track loading state
  isLoading: boolean = false;


  // ============================================================
  // ALL COURSES PAGE SECTIONS
  // ============================================================

  // Store active all courses section
  activeAllCoursesSection: 'POPULAR' | 'OTHER' = 'POPULAR';

  // Store other course options
  otherCourseOptions: string[] = ["001-TEST-COURSE"];

  // Store selected other course
  selectedOtherCourse = '';

  // Store custom other course
  customOtherCourse = '';

  // Store enquiry name
  otherEnquiryName = '';

  // Store enquiry email
  otherEnquiryEmail = '';

  // Store enquiry phone
  otherEnquiryPhone = '';

  // Store enquiry message
  otherEnquiryMessage = '';

  // Track other enquiry submission
  isSendingOtherEnquiry = false;

  // Store other enquiry error message
  otherEnquiryErrorMessage = '';

  // Store other enquiry success message
  otherEnquirySuccessMessage = '';

  // Store current page
  currentPage: number = 1;

  // Store page size
  pageSize: number = 8;

  // SQL total for server-side lists; client lists use courses.length.
  totalRecords: number = 0;

  // Use the exact loader for the currently displayed list.
  private paginationMode: 'server' | 'client' = 'client';
  private currentListAction: 'GET_BY_TYPE' | 'GET_SKILL_BY_TYPE' | null = null;
  private currentListType: string = '';
  private courseRequestId = 0;


  // Control enquiry success popup visibility
  showEnquirySuccessPopup: boolean = false;

  //store search keyword
  searchKeyword: string = "";

  //store selected course filter
  selectedCourseFilter: string = '';

  //store short course options list
  shortCourseOptions: any[] = [];

  //store main component
  isMainComponent: boolean = false;

  //store states list 
  statesList: StateModel[] = [];

  //store form state code
  selectedShortCourseStateCode: string = '';


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private adminService: AdminService
  ) {
  }


  // Initialise course list
  ngOnInit(): void {



    // Read route query parameters
    this.route.queryParamMap.subscribe(params => {

      // Check if the URL path is /course-short
      this.isMainComponent = this.router.url.split('?')[0] === '/course-short';

      // Store course type from URL
      this.courseType = (params.get('type') ?? 'ALL').toUpperCase();
      this.selectedShortCourseStateCode = (params.get('state_code') ?? localStorage.getItem('selectedStateCode') ?? 'MEL').toUpperCase();



      // Reset current page
      this.currentPage = 1;

      // Set default all courses section
      this.activeAllCoursesSection = 'POPULAR';
 
      // Load all courses
      if (this.courseType === 'ALL' || this.courseType === 'ALL_COURSES') {

        this.searchKeyword =
          params.get('searchKey') ?? '';

        this.selectedCourseFilter =
          params.get('search') ?? '';

        this.selectedShortCourseStateCode = (params.get('state_code') ?? 'mel').toUpperCase();

        this.loadShortCourses(this.courseType);

      } else if (this.courseType === 'VOC' || this.courseType === 'voc') {

        // Load VOC courses
        this.loadVOCCourses();

      } else if (this.courseType === 'ALL_SHORT_COURSES') {
        this.searchKeyword = params.get('searchKey') ?? '';

        this.selectedShortCourseStateCode = (params.get('state_code') ?? 'mel').toUpperCase();

        this.selectedCourseFilter =
          params.get('search') ?? '';
        // Load short courses by type
        this.loadShortCourses('all_courses');

      } else if (this.courseType === 'SS') {
        this.selectedShortCourseStateCode = (params.get('state_code') ?? 'mel').toUpperCase();
        this.loadSkillSetsCourses(this.courseType);
      } else {

        // Load short courses by type
        this.loadShortCourses(this.courseType);

      }

    });

    this.loadStates();

  }


  loadStates(): void {

    this.adminService.getStatesService('ALL_ACTIVE').subscribe({
      next: (response: StateModel[]) => {
        this.statesList = response || [];
        this.loadLocalStorageStateCode();
      },
      error: error => {
        console.error('Failed to load states:', error);
        this.statesList = [];
      }
    });

  }


  //get local storage code
  loadLocalStorageStateCode() {
    const savedStateCode = localStorage.getItem('selectedStateCode');
    const selectedState = this.statesList.find(
      x => x.code === savedStateCode
    );

    // Use saved location if valid, otherwise default to MEL
    const stateCode = selectedState
      ? selectedState.code
      : 'MEL';

    this.selectedShortCourseStateCode = stateCode;

    this.loadDropdownUOCCourses();

  }
  onShortCourseStateChange(stateCode: string): void {
    this.selectedShortCourseStateCode = stateCode;
    const selectedState = this.statesList.find(
      x => x.code === stateCode
    );
    //if location is remove it already
    const location = localStorage.removeItem('selectedStateCode');
    // Save selected location
    localStorage.setItem('selectedStateCode', stateCode);
    this.loadDropdownUOCCourses();
    this.searchShortCourses();
  }

  // Load all courses
  loadAllCourses(): void {

    this.paginationMode = 'client';
    this.currentListAction = null;
    ++this.courseRequestId;

    // Start loading
    this.isLoading = true;

    // Load UOC and VOC courses
    forkJoin({

      uoc: this.adminService.GetXCourseListByType('GET_BY_TYPE', 'ALL', this.searchKeyword, this.selectedCourseFilter, true),

      voc: this.adminService.getXVOCList('GET_ALL')

    }).subscribe({

      next: (response: any) => {

        // Store UOC courses
        this.allUOCCourses =
          (response.uoc || []).map((course: any) => ({
            ...course,
            courseType: 'UOC'
          }));

        // Store VOC courses
        this.allVOCCourses =
          (response.voc || [])
            .filter((course: any) =>
              (course.isActive ?? course.IsActive ?? true) === true
            )
            .map((course: any) => ({
              ...course,
              courseType: 'VOC'
            }));

        // Merge both course lists
        this.courses = [
          ...this.allUOCCourses,
          ...this.allVOCCourses
        ];


        // Stop loading
        this.isLoading = false;
      },

      error: (error) => {

        // Log all courses error
        console.error(
          'All Courses Error:',
          error
        );

        // Reset course lists
        this.allUOCCourses = [];
        this.allVOCCourses = [];
        this.courses = [];

        // Stop loading
        this.isLoading = false;
      }

    });

  }


dropdownPageSize = 50;
  dropdownTotalRecords = 0;
  dropdownSearchText = '';
  dropdownLoading = false;
    dropdownHasLoaded = false;

  private loadedDropdownPages = new Set<number>();
  private loadingDropdownPages = new Set<number>();
  private dropdownRequestVersion = 0;
  private dropdownSearchTimer: ReturnType<typeof setTimeout> | null = null;
private dropdownScrollElement: HTMLElement | null = null;
 private dropdownScrollHandler = () => {
    const el = this.dropdownScrollElement;
    if (!el || el.scrollTop + el.clientHeight < el.scrollHeight - 35) {
      return;
    }
    this.onCourseDropdownScroll();
  };
  // ============================================================
  // INITIALISE DROPDOWN
  // ============================================================

  // ============================================================
// INITIALISE UOC DROPDOWN
// ============================================================

loadDropdownUOCCourses(): void {

  // Invalidate previous API responses
  this.dropdownRequestVersion++;

  // Reset pagination
  this.loadedDropdownPages.clear();
  this.loadingDropdownPages.clear();

  // Reset dropdown data
  this.shortCourseOptions = [];
  this.dropdownTotalRecords = 0;
  this.dropdownLoading = false;
  this.dropdownHasLoaded = false;

  // Load first 50 records
  this.loadDropdownPage(1);
}


  // ============================================================
  // LOAD DROPDOWN COURSES WITH SERVER-SIDE PAGINATION
  // ============================================================

  private loadDropdownPage(page: number): void {

    // Prevent invalid page requests
    if (page < 1) {
      return;
    }

    // Prevent multiple requests at the same time
    if (this.dropdownLoading) {
      return;
    }

    // Prevent loading an already loaded page
    if (this.loadedDropdownPages.has(page)) {
      return;
    }

    // Stop when all matching records have been loaded
    if (
      this.dropdownTotalRecords > 0 &&
      this.shortCourseOptions.length >= this.dropdownTotalRecords
    ) {
      return;
    }

    // Remember request version to ignore old responses
    const requestVersion = this.dropdownRequestVersion;

    // Prepare existing XCourseFilter
    const filter: XCourseFilter = {
      action: 'GET_ALL_DROPDOWN_PAGED',
      type: '',
      search: this.dropdownSearchText?.trim() || '',
      searchKey: '',
      isActive: true,
      stateCode: this.selectedShortCourseStateCode || '',
      currentPage: page,
      pageSize: this.dropdownPageSize
    };

    // Start loading
    this.dropdownLoading = true;

    // Mark page as loading
    this.loadingDropdownPages.add(page);

    // Request only the selected page
    this.adminService
      .getXCourseDropdownPage(filter)
      .subscribe({

         next: (response) => {

  if (requestVersion !== this.dropdownRequestVersion) {
    return;
  }

  const records = response?.records || [];

  this.dropdownTotalRecords =
    Number(response?.totalRecords || 0);

  const existingIds = new Set(
    this.shortCourseOptions.map(course => Number(course.id))
  );

  const newRecords = records.filter(
    (course: any) =>
      course != null &&
      !existingIds.has(Number(course.id))
  );

  this.shortCourseOptions = [
    ...this.shortCourseOptions,
    ...newRecords
  ];

  this.loadedDropdownPages.add(page);
  this.loadingDropdownPages.delete(page);

  this.dropdownHasLoaded = true;
  this.dropdownLoading = false;
},

        error: (error) => {

          // Ignore outdated responses
          if (
            requestVersion !== this.dropdownRequestVersion
          ) {
            return;
          }

          console.error(
            'Error loading course dropdown page:',
            error
          );

          // Clear loading state
          this.loadingDropdownPages.delete(page);

          this.dropdownLoading = false;
        }

      });
  }


  // Load first page when dropdown opens
onCourseDropdownOpened(): void {

  if (!this.dropdownHasLoaded && !this.dropdownLoading) {
    this.loadDropdownPage(1);
  }

  setTimeout(() => {

    this.dropdownScrollElement?.removeEventListener(
      'scroll',
      this.dropdownScrollHandler
    );

    const panel = document.querySelector(
      '.ecb-short-course-dropdown-panel'
    );

    this.dropdownScrollElement =
      panel?.querySelector(
        '.p-dropdown-items-wrapper'
      ) as HTMLElement | null;

    this.dropdownScrollElement?.addEventListener(
      'scroll',
      this.dropdownScrollHandler
    );

  }, 0);
}


// Load next 50 records
onCourseDropdownScroll(): void {

  if (
    this.dropdownLoading ||
    !this.dropdownHasLoaded ||
    this.loadedDropdownPages.size === 0 ||
    this.shortCourseOptions.length >= this.dropdownTotalRecords
  ) {
    return;
  }

  const nextPage = this.loadedDropdownPages.size + 1;

  this.loadDropdownPage(nextPage);
}


// Remove scroll listener when closed
onCourseDropdownClosed(): void {

  this.dropdownScrollElement?.removeEventListener(
    'scroll',
    this.dropdownScrollHandler
  );

  this.dropdownScrollElement = null;
}

  // ============================================================
  // LOAD ADDITIONAL PAGES WHEN SCROLLING
  // ============================================================

  onCourseDropdownLazyLoad(event: any): void {

    const first = Math.max(0, Number(event.first) || 0);

    const last = Math.max(
      first + 1,
      Number(event.last) || first + this.dropdownPageSize
    );

    const firstPage =
      Math.floor(first / this.dropdownPageSize) + 1;

    const lastPage =
      Math.floor((last - 1) / this.dropdownPageSize) + 1;

    for (let page = firstPage; page <= lastPage; page++) {
      this.loadDropdownPage(page);
    }
  }


  // ============================================================
  // SERVER-SIDE DROPDOWN SEARCH
  // ============================================================

  onDropdownSearch(value: string): void {

    if (this.dropdownSearchTimer) {
      clearTimeout(this.dropdownSearchTimer);
    }

    this.dropdownSearchTimer = setTimeout(() => {

      this.dropdownSearchText = value.trim();

      this.loadDropdownUOCCourses();

    }, 350);
  }

  searchShortCourses(): void {
    this.currentPage = 1;

    // Route by the actual page type. Do not send SS to GET_BY_TYPE.
    if (this.courseType === 'SS') {
      this.loadSkillSetsCourses('SS');
    } else if (this.courseType === 'VOC') {
      this.loadVOCCourses();
    } else if (this.courseType === 'ALL' || this.courseType === 'ALL_COURSES') {
      this.loadShortCourses('ALL_COURSES');
    } else if (this.courseType === 'ALL_SHORT_COURSES') {
      this.loadShortCourses('ALL_COURSES');
    } else {
      this.loadShortCourses(this.courseType || 'UOC');
    }
  }

  // ============================================================
  // SQL-PAGINATED SHORT COURSE LISTS
  // ============================================================

  loadSkillSetsCourses(type: string): void {
    this.loadCoursePage('GET_SKILL_BY_TYPE', type);
  }

  loadShortCourses(type: string): void {
    this.loadCoursePage('GET_BY_TYPE', type);
  }

  private loadCoursePage(
    action: 'GET_BY_TYPE' | 'GET_SKILL_BY_TYPE',
    type: string
  ): void {

    this.paginationMode = 'server';
    this.currentListAction = action;
    this.currentListType = type;

    const requestId = ++this.courseRequestId;
    const filter = {
      action,
      type,
      search: this.searchKeyword || '',
      searchKey: this.selectedCourseFilter || '',
      isActive: true,
      stateCode: this.selectedShortCourseStateCode || '',
      pageSize: this.pageSize,
      currentPage: this.currentPage
    };

    this.isLoading = true;

    this.adminService.GetXCourseOptimizedListByType(filter)
      .subscribe({
        next: (response: any) => {
          if (requestId !== this.courseRequestId) return;

          this.allUOCCourses = response?.records || [];
          this.courses = this.allUOCCourses;
          this.totalRecords = Number(response?.totalRecords ?? 0);
          this.isLoading = false;

          // An out-of-range page can occur when filters or data change.
          const lastPage = Math.max(1, Math.ceil(this.totalRecords / this.pageSize));
          if (this.currentPage > lastPage) {
            this.currentPage = lastPage;
            this.loadCoursePage(action, type);
          }
        },
        error: (error: any) => {
          if (requestId !== this.courseRequestId) return;
          console.error('Course load error:', error);
          this.allUOCCourses = [];
          this.courses = [];
          this.totalRecords = 0;
          this.isLoading = false;
        }
      });
  }

  // Load VOC courses
  loadVOCCourses(): void {

    this.paginationMode = 'client';
    this.currentListAction = null;
    ++this.courseRequestId;

    // Start loading
    this.isLoading = true;

    this.adminService
      .getXVOCList('GET_ALL')
      .subscribe({

        next: (response: any[]) => {

          // Store VOC courses
          this.allVOCCourses =
            response || [];

          // Store displayed courses
          this.courses =
            this.allVOCCourses;

          // Stop loading
          this.isLoading = false;
        },

        error: (error) => {

          // Log VOC error
          console.error(
            'VOC Error:',
            error
          );

          // Reset displayed courses
          this.courses = [];

          // Stop loading
          this.isLoading = false;
        }

      });

  }
  // Get course code
  getCourseCode(course: any): string {

    // Get course type
    const type =
      this.courseType === 'ALL'
        ? course?.courseType
        : this.courseType;

    // Return VOC code
    if (type === 'VOC') {
      return 'VOC - ' + course?.vocCode || 'VOC';
    }

    // Return UOC code
    return course?.courseCode || 'UOC';
  }


  // Get course type only
  getCourseCodeOnly(course: any): string {

    // Get course type
    const type =
      this.courseType === 'ALL'
        ? course?.courseType
        : this.courseType;

    // Return course type
    return type;
  }


  // ============================================================
  // COURSE TITLE
  // ============================================================

  // Get course title
  getCourseTitle(course: any): string {

    // Get course type
    const type =
      this.courseType === 'ALL'
        ? course?.courseType
        : this.courseType;

    // Return VOC title
    if (type === 'VOC') {
      return course?.vocName || 'VOC';
    }

    // Return UOC title
    return course?.courseTitle || '';
  }


  // ============================================================
  // COURSE DESCRIPTION
  // ============================================================

  // Get course description
  /*  getCourseDescription(course: any): string {
  
    if (
      course?.description &&
      course.description.trim().length > 0
    ) {
  
      const plainText =
        course.description
          .replace(/<[^>]*>/g, '')
          .trim();
  
      if (plainText.length > 100) {
        return plainText.substring(0, 100) + '...';
      }
  
      return plainText;
    }
  
    return '-';
  } */
  /* getCourseDescription(course: any): string {
  
      // Check course description
      if (
        course?.description &&
        course.description.trim().length > 0
      ) {
  
        return course.description;
      }
  
      // Return default description
      return '-';
    } */
  getCourseDescription(course: any): string {

    if (
      !course?.description ||
      course.description.trim().length === 0
    ) {
      return '-';
    }

    const maxLength = 80;

    const container =
      document.createElement('div');

    container.innerHTML =
      course.description;

    let currentLength = 0;
    let isTruncated = false;


    const truncateNode = (
      node: Node
    ): Node | null => {

      // Text node
      if (
        node.nodeType === Node.TEXT_NODE
      ) {

        const text =
          node.textContent || '';

        const remaining =
          maxLength - currentLength;

        if (remaining <= 0) {
          isTruncated = true;
          return null;
        }

        if (text.length > remaining) {

          currentLength += remaining;
          isTruncated = true;

          return document.createTextNode(
            text.substring(0, remaining)
          );
        }

        currentLength +=
          text.length;

        return document.createTextNode(
          text
        );
      }


      // HTML element
      if (
        node.nodeType === Node.ELEMENT_NODE
      ) {

        const clonedElement =
          (node as HTMLElement)
            .cloneNode(false) as HTMLElement;

        for (
          const child of Array.from(node.childNodes)
        ) {

          if (currentLength >= maxLength) {
            isTruncated = true;
            break;
          }

          const clonedChild =
            truncateNode(child);

          if (clonedChild) {
            clonedElement.appendChild(
              clonedChild
            );
          }
        }

        return clonedElement;
      }


      return null;
    };


    const result =
      document.createElement('div');


    for (
      const child of Array.from(container.childNodes)
    ) {

      if (currentLength >= maxLength) {
        isTruncated = true;
        break;
      }

      const clonedChild =
        truncateNode(child);

      if (clonedChild) {
        result.appendChild(
          clonedChild
        );
      }
    }


    // Add ... inside the last text node
    if (isTruncated) {

      const addEllipsis = (
        node: Node
      ): boolean => {

        const children =
          Array.from(node.childNodes)
            .reverse();

        for (
          const child of children
        ) {

          if (
            child.nodeType === Node.TEXT_NODE &&
            child.textContent?.trim()
          ) {

            // Remove existing trailing dots first
            const text =
              child.textContent
                .replace(/[\s.…]+$/, '');

            child.textContent =
              text + '...';

            return true;
          }

          if (
            child.nodeType === Node.ELEMENT_NODE
          ) {

            if (addEllipsis(child)) {
              return true;
            }
          }
        }

        return false;
      };


      addEllipsis(result);
    }


    return result.innerHTML;
  }
  // ============================================================
  // COURSE IMAGE
  // ============================================================

  // Check course image
  hasCourseImage(course: any): boolean {

    return !!(
      course?.imageUrl &&
      course.imageUrl.trim().length > 0 &&
      !course.imageLoadFailed
    );
  }


  // Handle broken image
  onImageError(course: any): void {

    // Mark image load failure
    course.imageLoadFailed = true;
  }

  // Check course price availability
  hasPrice(course: any): boolean {

    return (
      (this.courseType === 'UOC' ||
        this.courseType === 'OSC' ||
        this.courseType === 'HRC') &&
      Number(course?.totalAmount ?? 0) > 0
    );
  }


  // Get course price
  getPrice(course: any): string {

    // Check price availability
    if (!this.hasPrice(course)) {

      return 'Enquire for pricing';
    }

    // Store currency code
    const currency =
      course?.currencyCode || 'AUD';

    // Format course price
    return new Intl.NumberFormat(
      'en-AU',
      {
        style: 'currency',
        currency: currency
      }
    ).format(
      Number(course.totalAmount)
    );
  }


  // Open course details
  openCourseDetails(course: any): void {


    // Read route query parameters
    this.route.queryParams.subscribe(params => {

      // Get current route with query parameters
      const currentUrl = this.router.url;

      // Store current URL in local storage
      localStorage.setItem(
        'PREVIOUS_COURSE_URL',
        currentUrl
      );

    });

    // Check course ID
    if (!course?.id) {
      return;
    }

    // Get course type
    const type = this.getCourseCodeOnly(course);

    // Navigate to course details
    this.router.navigate(
      ['/short-details'],
      {
        queryParams: {

          type: type?.toLowerCase(),

          id: course.id
        }
      }
    );
  }


  // ============================================================
  // PAGINATION (SQL for short/skill courses, local for VOC/combined)
  // ============================================================

  get paginatedCourses(): any[] {
    if (this.paginationMode === 'server') {
      // SQL already returns just the selected page.
      return this.courses;
    }

    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.courses.slice(startIndex, startIndex + this.pageSize);
  }

  get totalPages(): number {
    const count = this.paginationMode === 'server'
      ? this.totalRecords
      : this.courses.length;
    return Math.ceil(count / this.pageSize);
  }

  get pages(): number[] {
    const maxButtons = 5;
    const start = Math.max(
      1,
      Math.min(this.currentPage - 2, this.totalPages - maxButtons + 1)
    );
    const end = Math.min(this.totalPages, start + maxButtons - 1);
    return Array.from(
      { length: Math.max(0, end - start + 1) },
      (_, index) => start + index
    );
  }

  goToPage(page: number): void {
    if (this.isLoading || page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }

    this.currentPage = page;

    if (this.paginationMode === 'server' && this.currentListAction) {
      // Reload the *same* action/type that produced this list.
      this.loadCoursePage(this.currentListAction, this.currentListType);
    }

    document.getElementById('short-course-list')?.scrollIntoView({
      behavior: 'smooth', block: 'start'
    });
  }

  previousPage(): void {
    this.goToPage(this.currentPage - 1);
  }

  nextPage(): void {
    this.goToPage(this.currentPage + 1);
  }

  // Select all courses section
  selectAllCoursesSection(section: 'POPULAR' | 'OTHER'): void {

    // Set active section
    this.activeAllCoursesSection = section;

    // Reset enquiry messages
    this.otherEnquiryErrorMessage = '';
    this.otherEnquirySuccessMessage = '';
  }


  // Handle other course selection
  onOtherCourseSelectionChange(): void {

    // Reset custom course when not selected
    if (this.selectedOtherCourse !== 'OTHER') {
      this.customOtherCourse = '';
    }

    // Reset enquiry messages
    this.otherEnquiryErrorMessage = '';
    this.otherEnquirySuccessMessage = '';
  }


  // Get requested other course name
  get requestedOtherCourseName(): string {

    // Return custom course name
    if (this.selectedOtherCourse === 'OTHER') {
      return this.customOtherCourse?.trim() || '';
    }

    // Return selected course name
    return this.selectedOtherCourse?.trim() || '';
  }


  // Validate other course enquiry
  validateOtherCourseEnquiry(): boolean {

    // Reset enquiry error
    this.otherEnquiryErrorMessage = '';

    // Validate course selection
    if (!this.selectedOtherCourse) {

      this.otherEnquiryErrorMessage =
        'Please select a course, or choose Other to enter a course.';

      return false;
    }

    // Validate custom course name
    if (
      this.selectedOtherCourse === 'OTHER' &&
      !this.customOtherCourse?.trim()
    ) {

      this.otherEnquiryErrorMessage =
        'Please enter the course you would like to enquire about.';

      return false;
    }

    // Validate enquiry name
    if (!this.otherEnquiryName?.trim()) {

      this.otherEnquiryErrorMessage =
        'Please enter your name.';

      return false;
    }

    // Validate enquiry email
    if (!this.otherEnquiryEmail?.trim()) {

      this.otherEnquiryErrorMessage =
        'Please enter your email address.';

      return false;
    }

    // Store email validation pattern
    const emailPattern =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Validate email format
    if (
      !emailPattern.test(
        this.otherEnquiryEmail.trim()
      )
    ) {

      this.otherEnquiryErrorMessage =
        'Please enter a valid email address.';

      return false;
    }

    // Validate telephone number
    if (!this.otherEnquiryPhone?.trim()) {

      this.otherEnquiryErrorMessage =
        'Please enter your contact telephone number.';

      return false;
    }

    return true;
  }


  // Close enquiry success popup
  closeEnquirySuccessPopup(): void {

    // Hide success popup
    this.showEnquirySuccessPopup = false;

    // Navigate to home page
    this.router.navigate(['/']);
  }



  // Send other course enquiry
  sendOtherCourseEnquiry(): void {

    // Reset enquiry messages
    this.otherEnquirySuccessMessage = '';
    this.otherEnquiryErrorMessage = '';

    // Validate enquiry details
    if (!this.validateOtherCourseEnquiry()) {
      return;
    }

    // Create enquiry JSON
    const enquiryJson = {
      enquiryType: 'OTHER_COURSE_ENQUIRY',
      clientType: 'OTHER_COURSE_ENQUIRY',

      course: {
        selection: this.selectedOtherCourse === 'OTHER' ? 'OTHER' : 'LISTED_COURSE',
        courseName: this.requestedOtherCourseName
      },

      contactDetails: {
        name: this.otherEnquiryName.trim(),
        email: this.otherEnquiryEmail.trim(),
        telephone: this.otherEnquiryPhone.trim()
      },

      message: this.otherEnquiryMessage?.trim() || '',
      createdDate: new Date().toISOString()
    };

    // Create enquiry model
    const enquiryModel = {
      id: 0,
      body: JSON.stringify(enquiryJson),
      sentBy: this.otherEnquiryEmail.trim(),
      reviewedBy: null,
      reviewedDate: null,
      isApproved: false,
      isActive: true,
      clientType: 'OTHER_COURSE_ENQUIRY'
    };

    // Start enquiry submission
    this.isSendingOtherEnquiry = true;

    // Submit enquiry
    this.adminService.setXEnquiry(enquiryModel, 'INSERT').subscribe({

      next: (response: any) => {

        console.log(
          'Other Course Enquiry Response:',
          response
        );

        // Show success popup
        this.showEnquirySuccessPopup = true;

        // Stop enquiry submission
        this.isSendingOtherEnquiry = false;

        // Store success message
        this.otherEnquirySuccessMessage =
          'Your course enquiry has been sent successfully.';

        // Reset enquiry form
        this.selectedOtherCourse = '';
        this.customOtherCourse = '';
        this.otherEnquiryName = '';
        this.otherEnquiryEmail = '';
        this.otherEnquiryPhone = '';
        this.otherEnquiryMessage = '';
      },

      error: (error: any) => {

        console.error(
          'Other Course Enquiry Error:',
          error
        );

        // Stop enquiry submission
        this.isSendingOtherEnquiry = false;

        // Store enquiry error
        this.otherEnquiryErrorMessage =
          'Unable to send your enquiry. Please try again.';
      }
    });
  }
}